import { Avatar, Box, Grid, Tab } from '@material-ui/core'
import React, { useCallback, useEffect, useState } from 'react'
import { getDownloadURL, ref } from 'firebase/storage';
import { storage } from '../../firebase'; 
import { CircularProgress, Divider, Typography } from '@mui/material'
import { TabContext, TabList, TabPanel } from '@material-ui/lab'
import { metodoPrograma } from '../../components/api';
import Table from '../../components/Table';
import { format } from 'date-fns';

export const Cadastro = ({ objeto, voltar }) => {

  const [url, setUrl] = useState("");
  const [tab, setTab] = useState("1");
  const [listaPost, setListaPost] = useState([])
  const [listaSeguidor, setListaSeguidor] = useState([])
  const [listaSegue, setListaSegue] = useState([])
  const [listaSeguidorMes, setListaSeguidorMes] = useState([])
  const [carregando, setCarregando] = useState(false)

  const listarSeguidorMes = useCallback(() => {
    setCarregando(true);
    metodoPrograma('listaSeguidorMes', { idUsuarioSelecionado: objeto.usuario.idUsuario })
      .then((res) => {
        if (res.status) {
          setListaSeguidorMes(res.lista || []);
        }
        setCarregando(false);
      });
  }, [objeto.usuario.idUsuario]);

  const listaSeguidores = useCallback(() => {
    setCarregando(true);
    metodoPrograma('listaSeguidores', { idUsuarioSelecionado: objeto.usuario.idUsuario }, 'CtrlPerfil')
      .then((res) => {
        if (res.status) {
          setListaSeguidor(res.lista || []);
        }
        setCarregando(false);
      });
  }, [objeto.usuario.idUsuario]);

  const listaSeguindo = useCallback(() => {
    setCarregando(true);
    metodoPrograma('listaSeguindo', { idUsuarioSelecionado: objeto.usuario.idUsuario }, 'CtrlPerfil')
      .then((res) => {
        if (res.status) {
          setListaSegue(res.lista || []);
        }
        setCarregando(false);
      });
  }, [objeto.usuario.idUsuario]);
  
  const getListaPost = useCallback(() => {
    setCarregando(true);
    metodoPrograma('listaMeuPost', { idUsuarioSelecionado: objeto.usuario.idUsuario }, 'CtrlPerfil')
      .then((res) => {
        if (res.status) {
          setListaPost(res.lista || []);
        }
        setCarregando(false);
      });
  }, [objeto.usuario.idUsuario]);


  useEffect(() => {
    getListaPost();
  }, [getListaPost]);

  useEffect(() => {
    listaSeguindo();
  }, [listaSeguindo]);

  useEffect(() => {
    listaSeguidores();
  }, [listaSeguidores]);

  useEffect(() => {
    listarSeguidorMes();
  }, [listarSeguidorMes]);

  useEffect(() => {
    async function carregarFoto() {
      try {
        const caminho = `profile/${objeto.documento.dsToken}`;
        const storageRef = ref(storage, caminho);

        const downloadUrl = await getDownloadURL(storageRef);
        setUrl(downloadUrl);
      } catch (err) {
        console.error("Erro ao carregar foto:", err);
      }
    }

    carregarFoto();
    
  }, [objeto.documento.dsToken]);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Box
          style={{
            width: '99%',
            borderRadius: 10,
            backgroundColor: '#e2e2e2',
            margin: 10,
            marginRight: 15,
            padding: 15
          }}
        >
          <Grid container spacing={2}>
            <Grid item xs={12} >
              {objeto.usuario.dsNome}
              <Divider style={{marginTop: 10, marginBottom: 20}} />
            </Grid>
            <Grid item xs={2} alignContent='center' alignItems='center'>
              <Avatar
                alt="Remy Sharp"
                src={url}
                sx={{ width: 56, height: 56 }}
                style={{width: 150, height:150}}
              />
            </Grid>
            <Grid item xs={10}>
              <Typography variant="subtitle1" gutterBottom>
                <small>Nickname:</small> <br />{objeto.perfil.cdPerfil}
              </Typography>
              <Typography variant="subtitle1" gutterBottom>
                <small>Email:</small> <br />{objeto.usuario.dsEmail}
              </Typography>
              <Typography variant="subtitle1" gutterBottom>
                <small>biography:</small> <br />{objeto.perfil.dsBiografia}
              </Typography>
            </Grid>
          </Grid>
          
          
        </Box>
        
      </Grid>
      <Grid item xs={12} style={{padding: 25}}>
        <TabContext value={tab} >
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <TabList onChange={(_, t) => setTab(t)} aria-label="lab API tabs example">
              <Tab label="Post" value="1" />
              <Tab label="QikLooker per month" value="2" />
              <Tab label="QikLooker" value="3" />
              <Tab label="QikLooking" value="4" />
              <Tab label="Report" value="5" />
            </TabList>
          </Box>
          <TabPanel value="1"> 
            {carregando && <CircularProgress /> }
            <Grid container spacing={1}>
              {listaPost.map((post, index) => (
                <Grid item xs={3}>
                  <ThumbPost post={post} />
                </Grid>
              ))}
            </Grid>
          </TabPanel>
          <TabPanel value="2">
            <Table
              dados={listaSeguidorMes}
              head={['Date', 'Total']}
              line={(l) => [l[0] !== null ? format(l[0], 'MM/yyyy - MM:SS') : '', l[1]]}
            />
          </TabPanel>
          <TabPanel value="3">
            <Table
              dados={listaSeguidor}
              head={['Name', 'Inclusion']}
              line={(l) => [l.nmUsuario, l.dtInclusao !== null ? format(l.dtInclusao, 'MM/dd/yyyy - MM:SS') : '']}
              columnOptions={[
                {
                  alias: 0,
                  customJsx: ({ linhaOriginal }) => (
                    <Box style={{display: 'flex', alignItems: 'center' }}>
                      <AvatarPerfil dsToken={linhaOriginal.dsCaminhoPerfil} />
                      <span style={{ marginLeft: 8 }}>{linhaOriginal.nmUsuario}</span>
                    </Box>
                  ),
                },
              ]}
            />
          </TabPanel>
          <TabPanel value="4">
            <Table
              dados={listaSegue}
              head={['Name', 'Inclusion']}
              line={(l) => [l.nmUsuario, l.dtInclusao !== null ? format(l.dtInclusao, 'MM/dd/yyyy - MM:SS') : '']}
              columnOptions={[
                {
                  alias: 0,
                  customJsx: ({ linhaOriginal }) => (
                    <Box style={{display: 'flex', alignItems: 'center' }}>
                      <AvatarPerfil dsToken={linhaOriginal.dsCaminhoPerfil} />
                      <span style={{ marginLeft: 8 }}>{linhaOriginal.nmUsuario}</span>
                    </Box>
                  ),
                },
              ]}
            />
          </TabPanel>
          <TabPanel value="5">
            f
          </TabPanel>
        </TabContext>
      </Grid>
      
      
    </Grid>
  )
}

function ThumbPost({ post }) {
  const [url, setUrl] = useState(null);

  useEffect(() => {
    async function carregar() {
      try {
        const caminho = `thumb/${post.dsTokenPost}`;
        const storageRef = ref(storage, caminho);
        const downloadUrl = await getDownloadURL(storageRef);
        setUrl(downloadUrl);
      } catch (err) {
        console.error("Erro ao carregar thumb:", err);
      }
    }

    carregar();
  }, [post.dsTokenPost]);

  return (
    <Box
      sx={{
        width: '100%',
        height: 100,
        borderRadius: 6,
      }}
    >
      {url ? (
        <img
          alt="img"
          src={url}
          style={{ width: '100%', height: '100%', objectFit: 'cover' }}
        />
      ) : (
        <CircularProgress size={24} />
      )}
    </Box>
  );
}

function AvatarPerfil({ dsToken }) {
  const [url, setUrl] = useState(null);

  useEffect(() => {
    async function carregar() {
      try {
        const caminho = `profile/${dsToken}`;
        const storageRef = ref(storage, caminho);
        const downloadUrl = await getDownloadURL(storageRef);
        setUrl(downloadUrl);
      } catch (err) {
        console.error("Erro ao carregar thumb:", err);
      }
    }

    carregar();
  }, [dsToken]);

  return (
    <>
      {url ? (
        <Avatar
          alt="Remy Sharp"
          src={url}
        />
      ) : (
        <Avatar
          alt="Remy Sharp"
        />
      )}
    </>
  );
}



